import axios from "axios";
import axiosInstance from "./axiosInstance";

const queryString = require("query-string")

class HomeApi {

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async getFormulariosHome(params = {}) {    
    const cleanParams = Object.keys(params).reduce((acc, key) => {
      if (params[key] !== null && params[key] !== '' && params[key] !== undefined) {
        acc[key] = params[key];
      }
      return acc;
    }, {});

    const query = queryString.stringify(cleanParams);
    
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/home?${query}` 
    );
    return data;
  }

  async getUsuarioAtual() {
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/home/usuario_atual`
    );
    return data;
  }
  
 
  async getExpiraEm() {
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/home/expira_em_minutos`
    );
    return data;
  }

  async getUnidades() {
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/unidades`
    );
    return data;
  }
}

export default HomeApi;